import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import axiosInstance from 'src/common/axiosInstance';
import LineItemDropdown from './LineItemDropdown';
import AdvanceFilterModal from './AdvanceFilterModal';
import './calender.css';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../slices/store";
import {
  setSelectedAgency,
  setSelectedStatus,
  setSelectedOrder,
  setSelectedLineItems,
  setSelectedMediaType,
  setSelectedRateType,
  setSelectedExchangeType,
  setSelectedAdFormat,
  setStartDate,
  setEndDate,
  setChartServedImp,
  setDataBy,
  setTopNavReady,
  clearFilters,
  clearAllUserData,
} from "../../slices/Filters/reducer";
import { setSelectedReportOrder, setVisibleExchangeIds, setExchangeOrder } from "../../slices/Report/reducer";
import ExchangeFilterDropdown from "./ExchangeFilterDropdown";
import EmailReport from "src/pages/EmailReport/EmailReport";
import { startOfYear, endOfYear, subYears, startOfWeek, endOfWeek, startOfMonth, endOfMonth, subDays, subWeeks, subMonths } from 'date-fns';
import DataByDropdown, { OptionType } from "src/components/Common/DataByDropdown";
import CustomizeMetricsModal from "src/pages/ReportsPage/CustomizeMetricsModal";
import "../Common/common.css"
import CustomDatePicker from "src/common/CustomDatePicker";

export interface CampaignExchange {
  exchange_id: string;
  console_name: string;
  name: string;
  table: string;
  iconUrl: string;
  metrics: string[];
}

const TopNav = ({ captureWidget }: any) => {
  const [orders, setOrders] = useState<any[]>([]);
  const [agencys, setAgency] = useState<any[]>([]);
  const [lineItems, setLineItems] = useState<any[]>([]);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [mediaTypes, setMediaTypes] = useState<any[]>([]);
  const [dynamicMediaTypes, setDynamicMediaTypes] = useState<any[]>([]);
  const [rateTypes, setRateTypes] = useState<any[]>([]);
  const [exchangeTypes, setExchangeTypes] = useState<any[]>([]);
  const [adFormats, setAdFormats] = useState<any[]>([]);
  const [adFormatOptions, setAdFormatOptions] = useState<any[]>([]);
  const [orderName, setOrderName] = useState("");
  const [modalIsOpen, setIsOpen] = useState(false);
  const [customizeModalIsOpen, setCustomizeModalIsOpen] = useState(false);

  const dispatch = useDispatch();
  const filters = useSelector((state: RootState) => state.filters);
  const { user } = useSelector((state: any) => state.login);
  const agencyData = useSelector((state: any) => state.agency.agency.data);
  const [exchanges, setExchanges] = useState<any[]>([]);
  const [dateRangeLabel, setDateRangeLabel] = useState("");
  const location = useLocation();
  const [dataCheckFlag, setDataCheckFlag] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isUserSwitching, setIsUserSwitching] = useState(false);
  const [filterSelectionData, setFilterSelectionData] = useState<any>(null);
  const [chartDataReady, setChartDataReady] = useState(false);
  const [ordersDataReady, setOrdersDataReady] = useState(false);
  const [orderDateRange, setOrderDateRange] = useState<{ minDate: Date | null; maxDate: Date | null }>({ minDate: null, maxDate: null });
  const adminLoginRef = useRef(false);
  const wasAdminLoginRef = useRef(false); // Track if we were in admin login recently
  const fetchId = useRef(0); // Track request order to prevent stale data
  const apiCallsRef = useRef<{
    orders: string | false,
    lineItems: string | false,
    checkChart: boolean
  }>({
    orders: false,
    lineItems: false,
    checkChart: false
  });
  const userObj = user;
  const prevUserIdRef = useRef<string | null>(null);
  const prevUserTypeRef = useRef<string | null>(null);
  const {
    selectedAgency,
    selectedStatus,
    selectedOrder,
    selectedLineItems,
    selectedMediaType,
    selectedRateType,
    selectedExchangeType,
    selectedAdFormat,
    startDate,
    endDate,
    dataBy,
  } = filters;
  const { selectedExchangesData, visibleExchangeIds, exchangeOrder } = useSelector((state: RootState) => state.reports) || {};
  const formattedStartDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
  const formattedEndDate = new Date();
  const [date, setDate] = useState({
    startDate: formattedStartDate,
    endDate: formattedEndDate,
    key: "selection",
  });


  const activeFilterCount = [
    ...(selectedRateType ? selectedRateType.split(',').filter(item => item.trim() !== '') : []),
    ...(selectedExchangeType ? selectedExchangeType.split(',').filter(item => item.trim() !== '') : []),
    ...(selectedMediaType ? selectedMediaType.split(',').filter(item => item.trim() !== '') : []),
    ...(selectedAdFormat ? selectedAdFormat.split(',').filter(item => item.trim() !== '') : []),
  ].length;

  // Initialize filter local state from Redux and validate against options
  useEffect(() => {
    if (selectedMediaType && dynamicMediaTypes.length > 0) {
      const mediaValues = selectedMediaType.split(',').filter(item => item.trim() !== '');
      const mediaObjects = dynamicMediaTypes.filter((opt: any) =>
        mediaValues.includes(opt.value)
      );

      // Always update local state to use current media objects from new list
      setMediaTypes(mediaObjects);

      // Sync to Redux if invalid options were filtered out
      if (mediaObjects.length !== mediaValues.length) {
        const validMediaString = mediaObjects.map((item: any) => item.value).join(',');
        if (validMediaString !== selectedMediaType) {
          dispatch(setSelectedMediaType(validMediaString));
        }
      }
    }
  }, [dynamicMediaTypes]);

  useEffect(() => {
    if (selectedExchangeType && exchanges.length > 0) {
      const exchangeValues = selectedExchangeType.split(',').filter(item => item.trim() !== '');
      const exchangeObjects = exchanges.filter((opt: any) =>
        exchangeValues.includes(String(opt.value)) // Convert to string for comparison
      );

      // Always update local state to use current exchange objects from new list
      setExchangeTypes(exchangeObjects);

      // Sync to Redux if invalid options were filtered out
      if (exchangeObjects.length !== exchangeValues.length) {
        const validExchangeString = exchangeObjects.map((item: any) => item.value).join(',');
        if (validExchangeString !== selectedExchangeType) {
          dispatch(setSelectedExchangeType(validExchangeString));
        }
      }
    }
  }, [exchanges]);

  useEffect(() => {
    if (selectedRateType) {
      const rateValues = selectedRateType.split(',').filter(item => item.trim() !== '');
      const rateObjects = [
        { value: "cpm", label: "CPM" },
        { value: "cpa", label: "CPA" },
        { value: "flatfee", label: "Flat Fee" },
        { value: "percentage_fee", label: "Percentage Fee" },
      ].filter((opt: any) => rateValues.includes(opt.value));

      // Always update local state
      setRateTypes(rateObjects);

      // Sync to Redux if invalid options were filtered out
      if (rateObjects.length !== rateValues.length) {
        const validRateString = rateObjects.map((item: any) => item.value).join(',');
        if (validRateString !== selectedRateType) {
          dispatch(setSelectedRateType(validRateString));
        }
      }
    } else {
      // Clear local state when Redux is empty
      setRateTypes([]);
    }
  }, [selectedRateType]);

  useEffect(() => {
    if (selectedAdFormat && adFormatOptions.length > 0) {
      const adFormatValues = selectedAdFormat.split(',').filter(item => item.trim() !== '');
      const adFormatObjects = adFormatOptions.filter((opt: any) =>
        adFormatValues.includes(opt.value)
      );

      // Always update local state to use current ad format objects from new list
      setAdFormats(adFormatObjects);

      // Sync to Redux if invalid options were filtered out
      if (adFormatObjects.length !== adFormatValues.length) {
        const validAdFormatString = adFormatObjects.map((item: any) => item.value).join(',');
        if (validAdFormatString !== selectedAdFormat) {
          dispatch(setSelectedAdFormat(validAdFormatString));
        }
      }
    }
  }, [adFormatOptions]);

  useEffect(() => {
    if (filters.startDate === "" || filters.endDate === "") {
      setDate({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        key: "selection",
      });
    } else {
      // Parse date string in local timezone to avoid timezone shift
      const parseLocalDate = (dateStr: string) => {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day);
      };
      setDate({
        startDate: parseLocalDate(filters.startDate),
        endDate: parseLocalDate(filters.endDate),
        key: "selection",
      });
    }
  }, [filters.startDate, filters.endDate]);

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Pending", label: "Pending" },
    { value: "Cancelled", label: "Cancelled" },
    { value: "Finished", label: "Finished" },
    { value: "Paused", label: "Paused" },
  ];

  const rateTypeOptions = [
    { value: "cpm", label: "CPM" },
    { value: "cpa", label: "CPA" },
    { value: "flatfee", label: "Flat Fee" },
    { value: "percentage_fee", label: "Percentage Fee" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance('/exchange-types', {
          params: { order_id: selectedOrder }
        });
        setExchanges(response.data.data);

        // If order has no exchange options, clear any existing selections
        if (response.data.data.length === 0 && selectedExchangeType) {
          dispatch(setSelectedExchangeType(""));
          setExchangeTypes([]);
        }
      } catch (error) {
        console.error("Error fetching exchange types:", error);
        setExchanges([]);
      }
    };

    if (!isInitialized) return; // Don't fetch until checkChartDataFast completes

    if (selectedOrder && location.pathname !== '/reports') {
      fetchData();
    } else if (!selectedOrder && location.pathname !== '/reports') {
      // Clear exchange options when order is empty (but keep Redux selections for validation)
      setExchanges([]);
      setExchangeTypes([]);
    }
  }, [selectedOrder, isInitialized]);

  useEffect(() => {
    const fetchAdFormats = async () => {
      try {
        const response = await axiosInstance('/ad-formats', {
          params: { order_id: selectedOrder }
        });
        setAdFormatOptions(response.data.data);

        // If order has no ad format options, clear any existing selections
        if (response.data.data.length === 0 && selectedAdFormat) {
          dispatch(setSelectedAdFormat(""));
          setAdFormats([]);
        }
      } catch (error) {
        console.error("Error fetching ad formats:", error);
        setAdFormatOptions([]);
      }
    };

    if (!isInitialized) return; // Don't fetch until checkChartDataFast completes

    if (selectedOrder && location.pathname !== '/reports') {
      fetchAdFormats();
    } else if (!selectedOrder && location.pathname !== '/reports') {
      // Clear ad format options when order is empty (but keep Redux selections for validation)
      setAdFormatOptions([]);
      setAdFormats([]);
    }
  }, [selectedOrder, isInitialized]);

  useEffect(() => {
    const fetchMediaTypes = async () => {
      try {
        const response = await axiosInstance('/media-types', {
          params: { order_id: selectedOrder }
        });
        setDynamicMediaTypes(response.data.data);

        // If order has no media type options, clear any existing selections
        if (response.data.data.length === 0 && selectedMediaType) {
          dispatch(setSelectedMediaType(""));
          setMediaTypes([]);
        }
      } catch (error) {
        console.error("Error fetching media types:", error);
        setDynamicMediaTypes([]);
      }
    };

    if (!isInitialized) return; // Don't fetch until checkChartDataFast completes
    if (location.pathname == '/reports') return;

    if (selectedOrder) {
      fetchMediaTypes();
    } else {
      // Clear media type options when order is empty (but keep Redux selections for validation)
      setDynamicMediaTypes([]);
      setMediaTypes([]);
    }
  }, [selectedOrder, isInitialized]);

  const customTagStyles = {
    multiValue: (provided: any) => ({
      ...provided,
      backgroundColor: "#007bff",
      padding: "2px 6px",
    }),
    multiValueLabel: (provided: any) => ({
      ...provided,
      color: "white",
      fontWeight: "bold",
    }),
    multiValueRemove: (provided: any) => ({
      ...provided,
      color: "white",
      cursor: "pointer",
      ':hover': {
        backgroundColor: "#0056b3",
        color: "white",
      },
    }),
  };

  // Helper function to calculate appropriate dataBy based on date range
  const calculateAppropriateDataBy = (startDate: string | Date, endDate: string | Date): 'day' | 'week' | 'month' | 'quarter' | 'year' => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const daysDiff = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

    // < 7 days = 'day', otherwise default to 'week'
    if (daysDiff < 7) {
      return 'day';  // Only valid option for < 7 days
    } else {
      // For >= 7 days, default to 'week' but preserve valid user selection
      const validOptions = daysDiff < 30 ? ['day', 'week'] :
                           daysDiff < 92 ? ['day', 'week', 'month'] :
                           daysDiff < 365 ? ['day', 'week', 'month', 'quarter'] :
                           ['day', 'week', 'month', 'quarter', 'year'];

      // Keep current selection if valid, otherwise default to 'week'
      return validOptions.includes(filters.dataBy) ? filters.dataBy : 'week';
    }
  };

  const handleDateChange = (ranges: any) => {
    setDate(ranges.selection);
    // Format dates as YYYY-MM-DD to avoid timezone issues
    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    const formattedStartDate = formatDate(ranges.selection.startDate);
    const formattedEndDate = formatDate(ranges.selection.endDate);

    // Helper to calculate intersection with order date range
    const calculateIntersection = (startDate: Date, endDate: Date) => {
      if (!orderDateRange.minDate || !orderDateRange.maxDate) {
        return { startDate, endDate };
      }
      const intersectionStart = startDate > orderDateRange.minDate ? startDate : orderDateRange.minDate;
      const intersectionEnd = endDate < orderDateRange.maxDate ? endDate : orderDateRange.maxDate;
      return { startDate: intersectionStart, endDate: intersectionEnd };
    };

    // Define your static ranges (must match your customStaticRanges in DatePicker)
    const staticRanges = [
      {
        label: 'Today',
        range: () => calculateIntersection(new Date(), new Date()),
      },
      {
        label: 'Yesterday',
        range: () => calculateIntersection(subDays(new Date(), 1), subDays(new Date(), 1)),
      },
      {
        label: 'Last 7 Days',
        range: () => calculateIntersection(subDays(new Date(), 6), new Date()),
      },
      {
        label: 'Last 15 Days',
        range: () => calculateIntersection(subDays(new Date(), 14), new Date()),
      },
      {
        label: 'This Week',
        range: () => calculateIntersection(startOfWeek(new Date()), new Date()),
      },
      {
        label: 'Last Week',
        range: () => calculateIntersection(startOfWeek(subWeeks(new Date(), 1)), endOfWeek(subWeeks(new Date(), 1))),
      },
      {
        label: 'This Month',
        range: () => calculateIntersection(startOfMonth(new Date()), new Date()),
      },
      {
        label: 'Last Month',
        range: () => calculateIntersection(startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))),
      },
      {
        label: 'Last 30 Days',
        range: () => calculateIntersection(subDays(new Date(), 29), new Date()),
      },
      {
        label: 'This Year',
        range: () => calculateIntersection(startOfYear(new Date()), new Date()),
      },
      {
        label: 'Last Year',
        range: () => calculateIntersection(startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))),
      },
      {
        label: 'All Data',
        range: () => {
          const minDate = orderDateRange.minDate || new Date(2016, 0, 1);
          const maxDate = orderDateRange.maxDate || new Date();
          return { startDate: minDate, endDate: maxDate };
        },
      },
    ];

    // Function to compare two dates (ignoring time)
    const isSameDay = (d1: Date, d2: Date) =>
      d1.toDateString() === d2.toDateString();

    // Find the label that matches the current range
    const selectedLabel = staticRanges.find((rangeObj) => {
      const { startDate, endDate } = rangeObj.range();
      return (
        isSameDay(startDate, ranges.selection.startDate) &&
        isSameDay(endDate, ranges.selection.endDate)
      );
    })?.label || '';
    setDateRangeLabel(selectedLabel);
    dispatch(setStartDate(formattedStartDate));
    dispatch(setEndDate(formattedEndDate));

    // Calculate and set appropriate dataBy for the selected date range
    const appropriateDataBy = calculateAppropriateDataBy(ranges.selection.startDate, ranges.selection.endDate);
    if (appropriateDataBy !== filters.dataBy) {
      dispatch(setDataBy(appropriateDataBy));
    }
  };

  useEffect(() => {
    // Only set global default after initialization and when no order is selected
    if (!isInitialized) return;
    if (selectedOrder) return;

    // Format date in local timezone to avoid timezone shift
    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const oneMonthAgo = new Date(today);
    oneMonthAgo.setMonth(today.getMonth() - 1);

    const formattedStartDate = formatDate(oneMonthAgo);
    const formattedEndDate = formatDate(today);
    if (filters.startDate === "" || filters.endDate === "") {
      dispatch(setStartDate(formattedStartDate));
      dispatch(setEndDate(formattedEndDate));

      // Set appropriate dataBy for the default 30-day range
      const appropriateDataBy = calculateAppropriateDataBy(oneMonthAgo, today);
      if (appropriateDataBy !== filters.dataBy) {
        dispatch(setDataBy(appropriateDataBy));
      }
    }
  }, [dispatch, isInitialized, selectedOrder]);

  // Master data fetching effect - only runs when truly necessary
  useEffect(() => {
    if (!userObj) {
      return;
    }
    if (!isInitialized) {
      return; // Wait for initialization to complete
    }
    if (isUserSwitching) {
      return; // Don't fetch during user switching
    }
    if (adminLoginRef.current) {
      return; // Don't fetch during admin login
    }

    const fetchData = async () => {
      const currentRequestId = ++fetchId.current; // Increment to track this request
      try {
        const userId = userObj.user.users_id;
        const usersType = userObj.user.user_type;

        // For Client users, wait for agency data
        if (usersType === 'Client' && !agencyData?.Id) {
          return;
        }

        const currentApiKey = `${userId}-${usersType}-${selectedStatus}-${selectedAgency}-${agencyData?.Id || 'null'}`;

        // Prevent duplicate calls with same parameters
        if (apiCallsRef.current.orders && apiCallsRef.current.orders === currentApiKey) {
          return;
        }

        // Fetch agencies only if not already loaded (skip on agency selection change)
        if (usersType !== 'Client' && agencys.length === 0) {
          const agencyResponse = await axiosInstance.get<any[]>(`/get-agency`, {
            params: { user_id: userId, user_type: usersType, status: selectedStatus },
          });

          // Only update if this is still the latest request
          if (currentRequestId !== fetchId.current) {
            console.warn('Stale agency response - ignoring');
            return;
          }

          setAgency(agencyResponse.data);

          // Set agency selection 
          if (agencyResponse.data.length > 0) {
            // Re-apply agency 
            if (filterSelectionData && filterSelectionData.agency_id) {
              const existingAgency = agencyResponse.data.find(agency => agency.account_id === filterSelectionData.agency_id);
              if (existingAgency) {
                dispatch(setSelectedAgency(existingAgency.account_id));
              } else if (!selectedAgency) {
                // Fallback to first agency if agency not found
                dispatch(setSelectedAgency(agencyResponse.data[0].account_id));
              }
            } else if (!selectedAgency) {
              // Set default agency if none selected
              dispatch(setSelectedAgency(agencyResponse.data[0].account_id));
            }
          }
        }

        // Determine which agency to use for orders
        const agencyForOrders = usersType === 'Client'
          ? agencyData.Id
          : (selectedAgency || (agencys.length > 0 ? agencys[0].account_id : ''));

        // Fetch orders
        const response = await axiosInstance.get<any[]>(`/orders`, {
          params: {
            user_id: userId,
            user_type: usersType,
            status: selectedStatus,
            agency: agencyForOrders
          },
        });

        // Only update if this is still the latest request
        if (currentRequestId !== fetchId.current) {
          console.warn('Stale orders response - ignoring');
          return;
        }

        setOrders(response.data);
        apiCallsRef.current.orders = currentApiKey;

        // Clear line items flag to ensure refetch when order list changes
        apiCallsRef.current.lineItems = false;

        // Handle order selection - select first order by default
        if (response.data.length > 0) {
          let orderSelected = false;

          // Re-apply selections from fast API if available
          if (filterSelectionData && filterSelectionData.order_id) {
            const existingOrder = response.data.find(order => order.Id === filterSelectionData.order_id);
            if (existingOrder) {
              dispatch(setSelectedOrder(existingOrder.Id));
              setOrderName(existingOrder.Order_Name__c);
              dispatch(setSelectedReportOrder({ id: existingOrder.Id, name: existingOrder.Order_Name__c }));
              orderSelected = true;
            }
          }

          // Check current Redux selection
          if (!orderSelected && filters.selectedOrder) {
            const existingOrder = response.data.find(order => order.Id === filters.selectedOrder);
            if (existingOrder) {
              setOrderName(existingOrder.Order_Name__c);
              dispatch(setSelectedReportOrder({ id: existingOrder.Id, name: existingOrder.Order_Name__c }));
              orderSelected = true;
            }
          }

          // Fallback: Select first order if no valid selection found
          if (!orderSelected) {
            const firstOrder = response.data[0];
            dispatch(setSelectedOrder(firstOrder.Id));
            setOrderName(firstOrder.Order_Name__c);
            dispatch(setSelectedReportOrder({ id: firstOrder.Id, name: firstOrder.Order_Name__c }));
          }
          setOrdersDataReady(true);
        } else if (response.data.length === 0) {
          dispatch(setSelectedOrder(""));
          dispatch(setSelectedLineItems(""));
          setLineItems([]);
          setFilterSelectionData(null); // Clear stale filter data
          // Clear advanced filter selections when no orders are available
          dispatch(setSelectedRateType(""));
          dispatch(setSelectedMediaType(""));
          dispatch(setSelectedExchangeType(""));
          dispatch(setSelectedAdFormat(""));
          setOrdersDataReady(true);
        }

      } catch (error) {
        console.error("Error fetching data:", error);
        apiCallsRef.current.orders = false;
        // Clear selections if fetch fails
        setFilterSelectionData(null);
        dispatch(setSelectedOrder(""));
        dispatch(setSelectedAgency(""));
        setOrders([]);
        setAgency([]);
        // Clear advanced filter selections when fetch fails
        dispatch(setSelectedRateType(""));
        dispatch(setSelectedMediaType(""));
        dispatch(setSelectedExchangeType(""));
        dispatch(setSelectedAdFormat(""));
        setOrdersDataReady(true);
      }
    };

    fetchData();
  }, [selectedStatus, selectedAgency, userObj?.user?.users_id, userObj?.user?.user_type, agencyData?.Id, isInitialized, dataCheckFlag]);

  // Check for admin login transitions
  useEffect(() => {
    const checkAdminLogin = () => {
      const adminUser = localStorage.getItem("adminUser");
      const tempAuthUser = localStorage.getItem("tempAuthUser");

      // Only block initialization during ACTIVE admin login transitions
      // Check if user is actively changing (not just admin tokens existing)
      const isActiveAdminTransition = (adminUser || tempAuthUser) &&
        (prevUserIdRef.current && userObj?.user?.users_id &&
          prevUserIdRef.current !== userObj.user.users_id);

      if (isActiveAdminTransition) {
        adminLoginRef.current = true;
        wasAdminLoginRef.current = true;
        setIsUserSwitching(true);

        // Clear the flag after admin login is complete
        const clearAdminFlag = () => {
          setTimeout(() => {
            if (!localStorage.getItem("adminUser") && !localStorage.getItem("tempAuthUser")) {
              adminLoginRef.current = false;
              setIsUserSwitching(false);
              // Keep wasAdminLoginRef flag for a bit longer to detect reverse login
              setTimeout(() => {
                wasAdminLoginRef.current = false;
              }, 1000); // 1 second delay
              // Trigger data refresh after admin login ends
              setDataCheckFlag(prev => !prev);
            } else {
              clearAdminFlag(); // Keep checking
            }
          }, 100);
        };
        clearAdminFlag();
      } else if (!adminUser && !tempAuthUser) {
        // Clear flags when no admin tokens exist (but only if not recently in admin login)
        if (!wasAdminLoginRef.current) {
          adminLoginRef.current = false;
          setIsUserSwitching(false);
        }
      }
    };

    checkAdminLogin();

    // Check periodically for admin login changes
    const interval = setInterval(checkAdminLogin, 500);
    return () => clearInterval(interval);
  }, []);

  // Initialization effect - runs once per user session
  useEffect(() => {
    const initialize = async () => {
      try {
        if (userObj?.user?.users_id && userObj?.user?.user_type) {
          const currentUserId = userObj.user.users_id;
          const currentUserType = userObj.user.user_type;
          // Skip initialization if admin login is in progress
          const adminUser = localStorage.getItem("adminUser");
          const tempAuthUser = localStorage.getItem("tempAuthUser");
          if (adminLoginRef.current) {
            return;
          }

          // Check if user has changed and if this is a direct login
          const isDirectLogin = !prevUserIdRef.current && !prevUserTypeRef.current && userObj?.user?.users_id;
          const userHasChanged = (prevUserIdRef.current !== currentUserId) ||
            (prevUserTypeRef.current !== currentUserType);

          // Special case: Detect reverse admin login (Client -> admin with same user ID)
          const isSameUserDifferentType = (prevUserIdRef.current === currentUserId) &&
            (prevUserTypeRef.current !== currentUserType) &&
            (prevUserTypeRef.current !== null);
          const isReverseAdminLogin = prevUserIdRef.current === currentUserId &&
            prevUserTypeRef.current === 'Client' &&
            currentUserType === 'admin';

          if (userHasChanged || !prevUserIdRef.current || !prevUserTypeRef.current) {

            // Special handling for same user_id but different user_type 
            if (isSameUserDifferentType) {
              setIsUserSwitching(true);

              // Block all filter population until checkChartDataFast completes
              setIsInitialized(false);
              setFilterSelectionData(null);

              // Clear ALL API call tracking
              apiCallsRef.current = {
                orders: false,
                lineItems: false,
                checkChart: false
              };

              // Clear ALL Redux state
              dispatch(clearAllUserData());
              dispatch(setChartServedImp(0));

              // Clear ALL local state
              setOrders([]);
              setLineItems([]);
              setSelectedItems([]);
              setOrderName("");
              setAgency([]);
              setRateTypes([]);
              setExchangeTypes([]);
              setMediaTypes([]);
              setDataCheckFlag(false);
              setChartDataReady(false);
              setOrdersDataReady(false);

              // Update references
              prevUserIdRef.current = currentUserId;
              prevUserTypeRef.current = currentUserType;

              // Longer delay for same-user switches to ensure complete cleanup
              await new Promise(resolve => setTimeout(resolve, 500));

              setIsUserSwitching(false);

            } else {
              // Normal user change (different user_id)
              // Set user switching flag to prevent multiple API calls (but not for direct login)
              if (!isDirectLogin) {
                setIsUserSwitching(true);
              }

              // Block all filter population until checkChartDataFast completes
              setIsInitialized(false);
              setFilterSelectionData(null);

              // Clear all API call flags and data
              apiCallsRef.current = {
                orders: false,
                lineItems: false,
                checkChart: false
              };

              // Force clear all data immediately
              dispatch(clearAllUserData());
              setOrders([]);
              setLineItems([]);
              setSelectedItems([]);
              setOrderName("");
              setAgency([]);
              setRateTypes([]);
              setExchangeTypes([]);
              setMediaTypes([]);
              setDataCheckFlag(false);
              setChartDataReady(false);
              setOrdersDataReady(false);

              // Update references
              prevUserIdRef.current = currentUserId;
              prevUserTypeRef.current = currentUserType;

              // Small delay to ensure state is cleared (shorter for direct login)
              const delayTime = isDirectLogin ? 100 : 300;
              await new Promise(resolve => setTimeout(resolve, delayTime));

              // Clear user switching flag after state is stable (only if not admin login and not direct login)
              if (!adminLoginRef.current && !isDirectLogin) {
                setIsUserSwitching(false);
              }
            }
          }

          const usersType = userObj.user.user_type;

          if (!isSameUserDifferentType && apiCallsRef.current.checkChart && !isReverseAdminLogin) {
            setIsInitialized(true);
            return;
          }

          // Reset flag for reverse admin login
          if (isReverseAdminLogin || isSameUserDifferentType) {
            apiCallsRef.current.checkChart = false;
          }

          // For Client users, ensure agency data is available
          if (usersType === 'Client' && !agencyData?.Id) {
            // Client without agency data - mark everything as ready to prevent infinite loading
            setChartDataReady(true);
            setOrdersDataReady(true);
            setIsInitialized(true);
            return;
          }

          // Reset API flags if this is after admin login (but not for direct login/SSO/reverse admin login)
          const isRecentAdminTransition = wasAdminLoginRef.current;

          if (!adminLoginRef.current && !isUserSwitching && !isDirectLogin && !isRecentAdminTransition && !isReverseAdminLogin) {
            apiCallsRef.current.checkChart = false;
          }

          // SMART CHART DATA LOADING 
          try {
            // Step 1: Call fast chart data check API
            const chartResponse = await axiosInstance.get('/check-chart-data-fast', {
              params: {
                users_id: currentUserId,
                user_type: usersType,
                agency_id: usersType === 'Client' ? agencyData?.Id : null
              }
            });
            if (currentUserId !== userObj.user.users_id || usersType !== userObj.user.user_type) {
              console.warn('Stale API response detected - user context changed, ignoring response');
              return;
            }

            if (chartResponse.data && chartResponse.data.order_id) {
              // Set chart data 
              dispatch(setChartServedImp(chartResponse.data.chart_served_imp_count || 0));

              // Store in local state AND update Redux state
              if (chartResponse.data.order_id) {
                // Store in local state for re-applying after master fetch
                setFilterSelectionData({
                  order_id: chartResponse.data.order_id,
                  order_name: chartResponse.data.order_name || '',
                  agency_id: chartResponse.data.agency_id,
                  line_items: chartResponse.data.line_items || [],
                  start_date: chartResponse.data.start_date,
                  end_date: chartResponse.data.end_date
                });

                // Also update Redux state immediately
                dispatch(setSelectedOrder(chartResponse.data.order_id));
                setOrderName(chartResponse.data.order_name || '');
                dispatch(setSelectedReportOrder({
                  id: chartResponse.data.order_id,
                  name: chartResponse.data.order_name || ''
                }));

                // Set line items if available
                if (chartResponse.data.line_items && chartResponse.data.line_items.length > 0) {
                  dispatch(setSelectedLineItems(String(chartResponse.data.line_items)));
                  setSelectedItems(chartResponse.data.line_items);
                }

                // Set agency if available
                if (chartResponse.data.agency_id && usersType !== 'Client') {
                  dispatch(setSelectedAgency(chartResponse.data.agency_id));
                }
              }
            } else {
              dispatch(setChartServedImp(0));
              setFilterSelectionData(null);
            }

            apiCallsRef.current.checkChart = true;
            setDataCheckFlag(true);
            setChartDataReady(true);

          } catch (apiError) {
            console.error("Error in smart chart data initialization:", apiError);
            apiCallsRef.current.checkChart = true;
            dispatch(setChartServedImp(0));
            setDataCheckFlag(true);
            setChartDataReady(true);
          }
        } else {
          // Clear everything if no valid user is available
          prevUserIdRef.current = null;
          prevUserTypeRef.current = null;
          apiCallsRef.current = { orders: false, lineItems: false, checkChart: false };
          dispatch(clearAllUserData());
          setOrders([]);
          setLineItems([]);
          setSelectedItems([]);
          setOrderName("");
          setAgency([]);
          setRateTypes([]);
          setExchangeTypes([]);
          setMediaTypes([]);
          setDataCheckFlag(false);
          setChartDataReady(true);
          setOrdersDataReady(true);
          setIsInitialized(false);
          return;
        }

        setIsInitialized(true);
      } catch (error) {
        console.error("Error in initialization:", error);
        apiCallsRef.current = { orders: false, lineItems: false, checkChart: false };
        setDataCheckFlag(true);
        setIsInitialized(true);
      }
    };
    initialize();
  }, [user, dispatch, agencyData?.Id, userObj?.user?.users_id, userObj?.user?.user_type]);

  useEffect(() => {
    if (!userObj) return;
    // Only set global default after initialization and when no order is selected
    if (!isInitialized) return;
    if (selectedOrder) return;

    // Format date in local timezone to avoid timezone shift
    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const oneMonthAgo = new Date(today);
    oneMonthAgo.setMonth(today.getMonth() - 1);

    const formattedStartDate = formatDate(oneMonthAgo);
    const formattedEndDate = formatDate(today);

    if (filters.startDate === "" || filters.endDate === "") {
      dispatch(setStartDate(formattedStartDate));
      dispatch(setEndDate(formattedEndDate));

      // Set appropriate dataBy for the default 30-day range
      const appropriateDataBy = calculateAppropriateDataBy(oneMonthAgo, today);
      if (appropriateDataBy !== filters.dataBy) {
        dispatch(setDataBy(appropriateDataBy));
      }
    }
  }, [dispatch, userObj, isInitialized, selectedOrder]);

  useEffect(() => {
    dispatch(clearFilters());
    setRateTypes([]);
    setExchangeTypes([]);
    setMediaTypes([]);
    setAdFormats([]);
  }, [dispatch, user])

  // Signal when TopNav data pipeline is complete
  useEffect(() => {
    if (chartDataReady && ordersDataReady) {
      dispatch(setTopNavReady(true));
    } else {
      dispatch(setTopNavReady(false));
    }
  }, [chartDataReady, ordersDataReady, dispatch]);

  // Reset on unmount
  useEffect(() => {
    return () => {
      dispatch(setTopNavReady(false));
    };
  }, [dispatch]);

  // Separate useEffect for line items that triggers only when order changes
  useEffect(() => {
    if (!filters.selectedOrder) {
      setLineItems([]);
      setSelectedItems([]);
      dispatch(setSelectedLineItems(""));
      return;
    }

    if (!isInitialized) return; // Don't fetch until checkChartDataFast completes
    if (isUserSwitching) return; // Don't fetch during user switching
    if (adminLoginRef.current) return; // Don't fetch during admin login

    const currentLineItemKey = `lineItems-${filters.selectedOrder}`;
    if (apiCallsRef.current.lineItems === currentLineItemKey) {
      return; // Already fetched for this order
    }

    const fetchLineItems = async () => {
      try {
        const response = await axiosInstance.get<any[]>(`/line-items`, {
          params: { order_id: filters.selectedOrder }
        });

        if (response.data.length) {
          setLineItems(response.data);
          const allLineItemIds = response.data.map((item) => item.Id);
          setSelectedItems(allLineItemIds);
          dispatch(setSelectedLineItems(String(allLineItemIds)));
        } else {
          setLineItems([]);
          setSelectedItems([]);
          dispatch(setSelectedLineItems(""));
        }

        apiCallsRef.current.lineItems = currentLineItemKey;
      } catch (error) {
        console.error("Error fetching line items:", error);
        setLineItems([]);
        setSelectedItems([]);
        dispatch(setSelectedLineItems(""));
      }
    };

    fetchLineItems();
  }, [filters.selectedOrder, dispatch, isUserSwitching, isInitialized]);

  // Legacy fetchLineItems function for manual calls (mainly for checkChartData)
  const fetchLineItems = async (orderId: string) => {
    const currentLineItemKey = `lineItems-${orderId}`;
    if (apiCallsRef.current.lineItems === currentLineItemKey) {
      return; // Already fetched
    }

    try {
      const response = await axiosInstance.get<any[]>(`/line-items`,
        { params: { order_id: orderId } },
      );
      if (response.data.length) {
        setLineItems(response.data);
        const allLineItemIds = response.data.map((item) => item.Id);
        setSelectedItems(allLineItemIds);
        dispatch(setSelectedLineItems(String(allLineItemIds)));
      } else {
        setLineItems([]);
        setSelectedItems([]);
        dispatch(setSelectedLineItems(""));
      }
      apiCallsRef.current.lineItems = currentLineItemKey;
    } catch (error) {
      console.error("Error fetching line items:", error);
      setLineItems([]);
      setSelectedItems([]);
      dispatch(setSelectedLineItems(""));
    }
  };



  const handleOrderChange = (event: { value: string; label: string }) => {
    if (event.value === selectedOrder) {
      return;
    }
    // Reset line items API call flag for new order
    apiCallsRef.current.lineItems = false;

    dispatch(setSelectedOrder(event.value));
    setOrderName(event.label);
    setSelectedItems([]);
    dispatch(setSelectedReportOrder({ id: event.value, name: event.label }));
    // Don't call fetchLineItems manually - the useEffect will handle it
  };

  const handleStatusChange = (event: { value: string; label: string }) => {
    if (event.value === selectedStatus) return;
    dispatch(setSelectedOrder(""));
    dispatch(setSelectedStatus(event.value));
  };

  const handleAgencyChange = (selectedOption: { value: string; label: string }) => {
    if (selectedOption.value === selectedAgency) return;
    dispatch(setSelectedOrder(""));
    dispatch(setSelectedAgency(selectedOption.value));
  };

  // Helper function to sync filter state to Redux
  const syncFiltersToRedux = (
    rateTypesArr: any[],
    exchangeTypesArr: any[],
    mediaTypesArr: any[],
    adFormatsArr: any[]
  ) => {
    const rateTypesString = rateTypesArr.map((item: { value: string }) => item.value).join(',');
    const exchangeTypesString = exchangeTypesArr.map((item: { value: string }) => item.value).join(',');
    const mediaTypesString = mediaTypesArr.map((item: { value: string }) => item.value).join(',');
    const adFormatsString = adFormatsArr.map((item: { value: string }) => item.value).join(',');

    dispatch(setSelectedMediaType(mediaTypesString));
    dispatch(setSelectedRateType(rateTypesString));
    dispatch(setSelectedExchangeType(exchangeTypesString));
    dispatch(setSelectedAdFormat(adFormatsString));
  };

  const applyFiltersToRedux = () => {
    syncFiltersToRedux(rateTypes, exchangeTypes, mediaTypes, adFormats);
  };

  const optionsAgency = useMemo(() =>
    agencys.map((agency) => ({
      value: agency.account_id,
      label: agency.account_name,
    })),
    [agencys]
  );

  const optionsOrders = useMemo(() =>
    orders.map((order) => ({
      value: order.Id,
      label: order.Order_Name__c,
    })),
    [orders]
  );

  const handleCheckboxChange = (itemId: any) => {
    setSelectedItems((prevSelected) => {
      const updatedSelectedItems = prevSelected.includes(itemId)
        ? prevSelected.filter((id) => id !== itemId)
        : [...prevSelected, itemId];
      dispatch(setSelectedLineItems(String(updatedSelectedItems)));
      return updatedSelectedItems;
    });
  };

  const handleSelectAllChange = (allItemIds: any[]) => {
    setSelectedItems(allItemIds);
    dispatch(setSelectedLineItems(String(allItemIds)));
  };

  // handle data by dropdown change
  const handleTimeChange = (selected: OptionType | null) => {
    if (selected) {
      dispatch(setDataBy(selected.value as any));
    }
  };

  /**
   * Calculate default date range based on order dates
   * Sets 1 month from order start date, capped by order end date and today
   */
  const calculateDefaultDateRange = (orderStartDate: Date, orderEndDate: Date): { startDate: Date; endDate: Date } => {
    const today = new Date();

    // If the order hasn't started yet (future order), default to today's range
    if (orderStartDate > today) {
      return {
        startDate: today,
        endDate: today
      };
    }

    const oneMonthAfterStart = new Date(orderStartDate);
    oneMonthAfterStart.setMonth(oneMonthAfterStart.getMonth() + 1);

    // Use the earliest of: one month from start, order end date, or today
    const endDate = new Date(Math.min(oneMonthAfterStart.getTime(), orderEndDate.getTime(), today.getTime()));

    return {
      startDate: orderStartDate,
      endDate: endDate
    };
  };

  // Calculate order date range with fallback
  useEffect(() => {
    if (selectedOrder && orders.length > 0) {
      const currentOrder = orders.find(order => order.Id === selectedOrder);

      if (currentOrder?.EffectiveDate && currentOrder?.EndDate) {
        // Parse dates in local timezone to avoid timezone shift issues
        const parseLocalDate = (dateStr: string) => {
          const [year, month, day] = dateStr.split('-').map(Number);
          return new Date(year, month - 1, day);
        };

        const minDate = parseLocalDate(currentOrder.EffectiveDate);
        const maxDate = parseLocalDate(currentOrder.EndDate);

        // Validate dates are valid Date objects
        if (!isNaN(minDate.getTime()) && !isNaN(maxDate.getTime())) {
          setOrderDateRange({ minDate, maxDate });

          // Calculate default date range using the new function
          const { startDate: defaultStartDate, endDate: defaultEndDate } = calculateDefaultDateRange(minDate, maxDate);

          // Format dates as YYYY-MM-DD to avoid timezone issues
          const formatDate = (date: Date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
          };

          // Update Redux state with new default dates
          dispatch(setStartDate(formatDate(defaultStartDate)));
          dispatch(setEndDate(formatDate(defaultEndDate)));

          // Set appropriate dataBy for the order date range
          const appropriateDataBy = calculateAppropriateDataBy(defaultStartDate, defaultEndDate);
          if (appropriateDataBy !== filters.dataBy) {
            dispatch(setDataBy(appropriateDataBy));
          }
        } else {
          // Invalid dates - fallback to null (use defaults)
          setOrderDateRange({ minDate: null, maxDate: null });
        }
      } else {
        // No dates available - fallback to null (use defaults)
        setOrderDateRange({ minDate: null, maxDate: null });
      }
    } else {
      // No order selected - fallback to null (use defaults)
      setOrderDateRange({ minDate: null, maxDate: null });
    }
  }, [selectedOrder, orders, dispatch]);

  return (
    <>
      <CustomizeMetricsModal
        modalIsOpen={customizeModalIsOpen}
        closeModal={() => setCustomizeModalIsOpen(false)}
        selectedExchangesData={selectedExchangesData}
      />
      <AdvanceFilterModal
        modalIsOpen={modalIsOpen}
        closeModal={() => setIsOpen(false)}
        handleRateTypeChange={(selectedOptions) => setRateTypes(selectedOptions)}
        handleExchangeTypeChange={(selectedOptions) => setExchangeTypes(selectedOptions)}
        handleMediaTypeChange={(selectedOptions) => setMediaTypes(selectedOptions)}
        handleAdFormatChange={(selectedOptions) => setAdFormats(selectedOptions)}
        applyFiltersToRedux={applyFiltersToRedux}
        rateTypes={rateTypes}
        exchangeTypes={exchangeTypes}
        mediaTypes={mediaTypes}
        adFormats={adFormats}
        rateTypeOptions={rateTypeOptions}
        exchangeTypeOptions={exchanges}
        mediaTypeOptions={dynamicMediaTypes}
        adFormatOptions={adFormatOptions}
        customTagStyles={customTagStyles}
      />
      <div className="nav-container topnavjoy" >
        <div className="nav-left-grp" style={{ width: "100%" }}>
          {userObj.user.user_type != "Client" && (
            <div className="topnav-dropdown has-float-label" >
              <Select
                className="dropdown agency-select"
                classNamePrefix="react-select"
                value={optionsAgency.find((option) => option.value === selectedAgency)}
                onChange={handleAgencyChange}
                options={optionsAgency}
                placeholder=""
                styles={{
                  input: (provided: any) => ({
                    ...provided,
                    fontSize: '16px',// stops ios zoom
                    caretColor: 'transparent', // Hide cursor
                  }),
                  control: (base: any) => ({
                    ...base
                  }),
                  singleValue: (base: any) => ({
                    ...base,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 'calc(100% - 8px)',
                  }),
                  option: (base: any, state: any) => ({
                    ...base,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    backgroundColor: 'transparent',
                    color: 'inherit',
                    ':active': {
                      backgroundColor: 'transparent',
                    },
                  }),
                  menu: (base: any) => ({
                    ...base,
                    width: '340px',
                    zIndex: 1000,
                    borderRadius: '4px'
                  }),
                  menuList: (base: any) => ({
                    ...base,
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    borderRadius: "4px",
                  }),
                }}
              />
              <span>Agency</span>
            </div>
          )}
          <div className="topnav-dropdown has-float-label" >
            <Select
              className="dropdown status-select"
              classNamePrefix="react-select"
              value={statusOptions.find((option) => option.value === selectedStatus)}
              onChange={handleStatusChange}
              options={statusOptions}
              placeholder=""
              styles={{
                input: (provided: any) => ({
                  ...provided,
                  fontSize: '16px',// stops ios zoom
                  caretColor: 'transparent', // Hide cursor
                }),
                control: (base: any) => ({
                  ...base
                }),
                singleValue: (base: any) => ({
                  ...base,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: 'calc(100% - 8px)',
                }),
                option: (base: any) => ({
                  ...base,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  backgroundColor: 'transparent',
                  color: 'inherit',
                  ':active': {
                    backgroundColor: 'transparent',
                  },
                }),
                menu: (base: any) => ({
                  ...base,
                  width: '140px',
                  zIndex: 1000,
                  borderRadius: "4px",
                }),
                menuList: (base: any) => ({
                  ...base,
                  paddingTop: '0px',
                  paddingBottom: '0px',
                  borderRadius: "4px",
                }),
              }}
            />
            <span>Status</span>
          </div>
          <div className="topnav-dropdown has-float-label" >
            <Select
              className="dropdown order-select"
              classNamePrefix="react-select"
              value={optionsOrders.find((option) => option.value === selectedOrder) || null}
              onChange={handleOrderChange}
              options={optionsOrders}
              placeholder={orders.length === 0 ? "No Orders" : "Select Order"}
              noOptionsMessage={() => "No orders available"}
              styles={{
                input: (provided: any) => ({
                  ...provided,
                  fontSize: '16px',// stops ios zoom
                  caretColor: 'transparent', // Hide cursor
                }),
                control: (base: any) => ({
                  ...base,
                }),
                singleValue: (base: any) => ({
                  ...base,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: 'calc(100% - 8px)',
                }),
                option: (base: any) => ({
                  ...base,
                  whiteSpace: "normal",
                  overflow: "visible",
                  textOverflow: "clip",
                  lineHeight: "2.0",
                  padding: "5px",
                  backgroundColor: 'transparent',
                  color: 'inherit',
                  ':active': {
                    backgroundColor: 'transparent',
                  },
                }),
                menu: (base: any) => ({
                  ...base,
                  width: '300px',
                  zIndex: 1000,
                  borderRadius: '4px'
                }),
                menuList: (base: any) => ({
                  ...base,
                  paddingTop: '0px',
                  paddingBottom: '0px',
                  borderRadius: "4px",
                }),
              }}
            />
            <span>Order</span>
          </div>
          {location.pathname === '/analytics' ?
            (<>
              <div className="topnav-dropdown has-float-label" >
                <LineItemDropdown
                  lineItems={lineItems}
                  selectedItems={selectedItems}
                  handleCheckboxChange={handleCheckboxChange}
                  handleSelectAllChange={handleSelectAllChange}
                />
                <span>Line Items</span>
              </div>
              <div className="topnav-dropdown has-float-label" >
                {/* data by dropdown */}
                < DataByDropdown
                  selectedOption={dataBy}
                  onChange={handleTimeChange}
                />
                <span>Data By</span>
              </div>
            </>
            ) : location.pathname === '/reports' ? (
              <div className="topnav-dropdown has-float-label" >
                {/* data by dropdown */}
                < DataByDropdown
                  selectedOption={dataBy}
                  onChange={handleTimeChange}
                />
                <span>Data By</span>
              </div>
            ) : (
              <div className="topnav-dropdown has-float-label" >
                <LineItemDropdown
                  lineItems={lineItems}
                  selectedItems={selectedItems}
                  handleCheckboxChange={handleCheckboxChange}
                  handleSelectAllChange={handleSelectAllChange}
                />
                <span>Line Items</span>
              </div>
            )}
          <div className="topnav-dropdown has-float-label" >
            <CustomDatePicker
              date={date}
              handleDateChange={handleDateChange}
              orderMinDate={orderDateRange.minDate}
              orderMaxDate={orderDateRange.maxDate}
            />
            <span>Date Range</span>
          </div>
          {location.pathname === '/reports' && selectedExchangesData && selectedExchangesData.length >= 2 && (
            <ExchangeFilterDropdown
              exchanges={selectedExchangesData.map((ex: any) => ({ id: ex.id, name: ex.name }))}
              visibleIds={visibleExchangeIds || []}
              onChange={(ids) => dispatch(setVisibleExchangeIds(ids))}
              exchangeOrder={exchangeOrder || []}
              onReorder={(ids) => dispatch(setExchangeOrder(ids))}
            />
          )}
          <div className="nav-btn-grp">
            {location.pathname !== '/reports' ? (
              <>
                <div>
                  <div style={{ position: 'relative' }}>
                    <button
                      className="btn btn-primary button-primary"
                      style={{ whiteSpace: "nowrap" }}
                      onClick={() => setIsOpen(true)}
                    >
                      Advanced Filters
                    </button>
                    {activeFilterCount > 0 && (
                      <span
                        className="position-absolute d-flex align-items-center justify-content-center bg-primary text-white rounded-circle"
                        style={{
                          top: "-6px",
                          right: "-6px",
                          width: "18px",
                          height: "18px",
                          fontSize: "0.65rem",
                          border: "2px solid white",
                          cursor: "pointer",
                          zIndex: 1000
                        }}
                        title={`${activeFilterCount} ${activeFilterCount === 1 ? 'filter' : 'filters'} applied`}
                      >
                        {activeFilterCount > 99 ? '99+' : activeFilterCount}
                      </span>
                    )}
                  </div>
                </div>
                {/*<div>
              <WrapUpReport
                selectedOrder={selectedOrder}
                selectedItems={selectedItems}
                currentStartDate={startDate}
                currentEndDate={endDate}
                captureWidget={captureWidget}
              />
            </div>*/}
              </>
            ) :
              (<>
                <div>
                  <button className="btn btn-primary button-primary" style={{ whiteSpace: 'nowrap' }}
                    disabled={!selectedExchangesData || selectedExchangesData.length === 0}
                    onClick={() => setCustomizeModalIsOpen(true)}>Customize & Export All</button>

                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {userObj.user.user_type == 'Client' && (
                    <EmailReport
                      selectedOrder={selectedOrder}
                      selectedItems={selectedItems}
                      currentStartDate={startDate}
                      currentEndDate={endDate}
                      dateRangeLabel={dateRangeLabel}
                      selectedAgency={userObj.user.user_type == 'Client' ? agencyData.Id : selectedAgency}
                      reportDataBy={dataBy}
                    />

                  )}
                </div>
              </>
              )}
          </div>
        </div>
        <div className="desktop-nav-right-grp">
          {location.pathname !== '/reports' ? (
            <>
              <div>
                <div style={{ position: 'relative' }}>
                  <button
                    className="btn btn-primary button-primary"
                    style={{ whiteSpace: "nowrap" }}
                    onClick={() => setIsOpen(true)}
                  >
                    Advanced Filters
                  </button>
                  {activeFilterCount > 0 && (
                    <span
                      className="position-absolute d-flex align-items-center justify-content-center bg-primary text-white rounded-circle"
                      style={{
                        top: "-6px",
                        right: "-6px",
                        width: "18px",
                        height: "18px",
                        fontSize: "0.65rem",
                        border: "2px solid white",
                        cursor: "pointer",
                        zIndex: 1000
                      }}
                      title={`${activeFilterCount} ${activeFilterCount === 1 ? 'filter' : 'filters'} applied`}
                    >
                      {activeFilterCount > 99 ? '99+' : activeFilterCount}
                    </span>
                  )}
                </div>


              </div>

            </>
          ) :
            (<>
              <div>
                <button className="btn btn-primary button-primary" style={{ whiteSpace: 'nowrap' }}
                  disabled={!selectedExchangesData || selectedExchangesData.length === 0}
                  onClick={() => setCustomizeModalIsOpen(true)}>Customize & Export All</button>

              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {userObj.user.user_type == 'Client' && (
                  <EmailReport
                    selectedOrder={selectedOrder}
                    selectedItems={selectedItems}
                    currentStartDate={startDate}
                    currentEndDate={endDate}
                    dateRangeLabel={dateRangeLabel}
                    selectedAgency={userObj.user.user_type == 'Client' ? agencyData.Id : selectedAgency}
                    reportDataBy={dataBy}
                  />

                )}
              </div>
            </>
            )}
        </div>
      </div >
    </>

  );
};

export default TopNav;
